import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { delete_favorite_portfolio, get_select_one_community, get_select_one_portfolio_favorite, insert_favorite_portfolio } from "../../Axios";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import * as S from "../../style/StyleComponentSection";
import noImage from "../../assets/images/no_image_angle.png";
import leftArrow from "../../assets/icons/stroke_left.svg";
import rightArrow from "../../assets/icons/stroke_right.svg";
import closeIcon from "../../assets/icons/close_30.svg";
import bookmark_white from "../../assets/icons/bookmark_white.svg";
import bookmark_yellow from "../../assets/icons/bookmark_yellow.svg"

interface PortfolioObject {
  ablack_comunity_ID: number;
  ablack_comunity_brand_ID: number
  ablack_comunity_color_ID: number;
  ablack_comunity_customer_ID: number;
  ablack_comunity_division: number;
  ablack_comunity_division_name: string;
  ablack_comunity_high_status_name: string;
  ablack_comunity_modified: string;
  ablack_comunity_registe: any;
  ablack_comunity_review: string;
  ablack_comunity_top_status: number;
  color_name: string;
  product_kor_name: string;
  product_eng_name: string;
  brand_eng_name: string;
  brand_kor_name: string;
  ablack_comunity_square_meter_name: string;
  ablack_comunity_space_name: string;
};

const PortfolioSelectOne: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const customerData = useSelector((state: RootState) => state.customerData);

  const [portfolio, setPortfolio] = useState<PortfolioObject>();
  const [title, setTitle] = useState<string>("");
  const [imageList, setImageList] = useState<any[]>([]);
  const [bigImageSRC, setBigImageSRC] = useState<string>("");
  const [bigImageIndex, setBigImageIndex] = useState<number>(0);
  const [isFavorite, setIsFavorite] = useState<boolean>(false);

  const [modal, setModal] = useState<boolean>(false);

  useEffect(() => {
    get_select_one_community(state.ablack_comunity_ID, customerData.customer_ID).then(result => {
      let str = result.rows.product_eng_name;
      let title_list = str.split('/');
      setTitle(title_list[0]);
      setPortfolio(result.rows);
      let list: (string | null)[] = result.images;
      let image_list = list.filter(el => el !== null);
      setImageList(image_list);
      setBigImageSRC(result.images[0]);
      getFavorite();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData.customer_ID, state]);

  const getFavorite = () => {
    get_select_one_portfolio_favorite(state.ablack_comunity_ID, customerData.customer_ID).then(result => {
      if (result === 1) {
        setIsFavorite(true);
      } else {
        setIsFavorite(false);
      };
    });
  };

  useEffect(() => {
    if (modal) {
      document.body.classList.add('on-modal-back');
    } else {
      document.body.classList.remove('on-modal-back');
    }
  }, [modal]);

  return (
    <div>
      <S.SelectOnePortfolioTitleBox className="mt-[50px]">
        <div className="text-box">
          <h3>{title}</h3>
          <span>{portfolio?.ablack_comunity_division_name}</span>
          &nbsp;|&nbsp;
          <span>{portfolio?.brand_kor_name}</span>
        </div>
        <div className="icon-box">
          {isFavorite ?
            <img
              src={bookmark_yellow}
              alt=""
              onClick={() => {
                delete_favorite_portfolio(state.ablack_comunity_ID, customerData.customer_ID).then(result => {
                  if (result === 1) {
                    setIsFavorite(false);
                  }
                });
              }}
            />
            :
            <img
              src={bookmark_white}
              alt=""
              onClick={() => {
                insert_favorite_portfolio(state.ablack_comunity_ID, customerData.customer_ID).then(result => {
                  if (result === 1) {
                    setIsFavorite(true);
                  }
                })
              }}
            />
          }
        </div>
      </S.SelectOnePortfolioTitleBox>
      <S.SelectOnePortfolioImageBox className="mt-[30px]">
        <div
          className="big-image-box"
          onClick={() => {
            setModal(true);
          }}
        >
          <img src={bigImageSRC} alt="" />
        </div>
        <div className="image-list-box">
          {imageList[0] ?
            <div className="individaul-box" onClick={() => {
              setBigImageSRC(imageList[0]);
              setBigImageIndex(0)
            }}>
              <img width={130} height={87} src={imageList[0]} alt="" />
            </div>
            :
            <div>
              <img width={130} height={87} src={noImage} alt="" />
            </div>
          }
          {imageList[1] ?
            <div className="individaul-box" onClick={() => {
              setBigImageSRC(imageList[1]);
              setBigImageIndex(1)
            }}>
              <img width={130} height={87} src={imageList[1]} alt="" />
            </div>
            :
            <div>
              <img width={130} height={87} src={noImage} alt="" />
            </div>
          }
          {imageList[2] ?
            <div className="individaul-box" onClick={() => {
              setBigImageSRC(imageList[2]);
              setBigImageIndex(2)
            }}>
              <img width={130} height={87} src={imageList[2]} alt="" />
            </div>
            :
            <div>
              <img width={130} height={87} src={noImage} alt="" />
            </div>
          }
          {imageList[3] ?
            <div className="individaul-box" onClick={() => {
              setBigImageSRC(imageList[3]);
              setBigImageIndex(3)
            }}>
              <img width={130} height={87} src={imageList[3]} alt="" />
            </div>
            :
            <div>
              <img width={130} height={87} src={noImage} alt="" />
            </div>
          }
        </div>
      </S.SelectOnePortfolioImageBox>

      <S.SelectOnePortfolioContentBox>
        <div className="content-line border-b-[0.5px]">
          <div className="label-box">구분</div>
          <div className="content-box">{portfolio?.ablack_comunity_division_name}</div>
        </div>
        <div className="content-line border-b-[0.5px]">
          <div className="label-box">브랜드</div>
          <div className="content-box">{portfolio?.brand_kor_name}</div>
        </div>
        <div className="content-line border-b-[0.5px]">
          <div className="label-box">제품명</div>
          <div className="content-box">{portfolio?.product_kor_name} {portfolio?.color_name}</div>
        </div>
        <div className="content-line border-b-[0.5px]">
          <div className="label-box">천장높이</div>
          <div className="content-box">{portfolio?.ablack_comunity_high_status_name}</div>
        </div>
        <div className="content-line border-b-[0.5px]">
          <div className="label-box">전체 평수</div>
          <div className="content-box">{portfolio?.ablack_comunity_square_meter_name}</div>
        </div>
        <div className="content-line">
          <div className="label-box">설치 장소</div>
          <div className="content-box">{portfolio?.ablack_comunity_space_name}</div>
        </div>
      </S.SelectOnePortfolioContentBox>
      <div className="mb-14">
        <button
          className="text-middleGray02 hover:text-mainBlack"
          onClick={() => {
            navigate("/community");
          }}
        >
          뒤로가기
        </button>
      </div>

      {modal &&
        <S.SelectOnePortfolioModal onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          if (!(e.target instanceof HTMLImageElement)) {
            setModal(false);
          }
        }}>
          <div className="flex-box">
            <div className="close-box right-[8%] 2xl:right-[25%]">
              <img src={closeIcon} alt="" onClick={() => setModal(false)} />
            </div>

            <div className="arrow-box left-[8%] 2xl:left-[25%]">
              {imageList.length > 1 &&
                <button onClick={() => {
                  if (bigImageIndex !== 0) {
                    setBigImageIndex(bigImageIndex - 1);
                    setBigImageSRC(imageList[bigImageIndex - 1]);
                  } else if (bigImageIndex === 0) {
                    setBigImageIndex(imageList.length - 1);
                    setBigImageSRC(imageList[imageList.length - 1]);
                  }
                }}>
                  <img src={leftArrow} alt="" />
                </button>
              }
            </div>

            <div className="modal-image-box">
              <img src={bigImageSRC} alt="" />
            </div>

            <div className="arrow-box right-[8%] 2xl:right-[25%]">
              {imageList.length > 1 &&
                <button onClick={() => {
                  if (bigImageIndex + 1 < imageList.length) {
                    setBigImageIndex(bigImageIndex + 1);
                    setBigImageSRC(imageList[bigImageIndex + 1]);
                  } else {
                    setBigImageIndex(0);
                    setBigImageSRC(imageList[0]);
                  }
                }}>
                  <img src={rightArrow} alt="" />
                </button>
              }
            </div>
          </div>

          <div className="index-box">
            {bigImageIndex + 1} / {imageList.length}
          </div>

        </S.SelectOnePortfolioModal>
      }
    </div>
  )
};

export default PortfolioSelectOne;